// IE Polyfill  for "foreach"
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function CookieConsent() {
    this.cookies;
    this.cookiesEnabled = false;
    this.categories = [];
    this.cookieHasBeenOpen = false;
    this.tabelhead = function(cookieContent, cookiehead) {
        return `<table>
                    <thead>
                        <tr>
                            <th>${cookiehead.name}</th>
                            <th>${cookiehead.company}</th>
                            <th>${cookiehead.description}</th>
                            <th>${cookiehead.expires}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${cookieContent}
                    </tbody>
                </table>`;
    };
    this.tabelbody = function(cookie, singleCookie, cookiehead) {
        return `<tr>
                <td data-label="${cookiehead.name}">${singleCookie}</td>
                <td data-label="${cookiehead.company}">${cookie.company}</td>
                <td data-label="${cookiehead.description}">${cookie.description}</td>
                <td data-label="${cookiehead.expires}">${cookie.expires}</td>
            </tr>
            `;
    };
    this.cookiehead;

    //Native async request function to load json
    this.loadJSON = function(path, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    if (success) success(JSON.parse(xhr.responseText));
                } else {
                    if (error) error(xhr);
                }
            }
        };
        xhr.open("GET", path, true);
        xhr.send();
    };

    this.init = function() {
        var _self = this;
        document.addEventListener("DOMContentLoaded", function(event) {
            _self.cookiesEnabled =
                document.querySelector(".cookie-container") != null;

            if (_self.cookiesEnabled) {
                const hiddenInputCookiesContainer = document.querySelector(
                    "#hiddenInputCookiesContainer"
                );

                if (
                    hiddenInputCookiesContainer == null ||
                    hiddenInputCookiesContainer.value == ""
                ) {
                    const data = JSON.parse("[]");
                    _self.cookies = data;
                } else {
                    const data = JSON.parse(hiddenInputCookiesContainer.value);
                    _self.cookies = data;
                }

                _self.createGlobalCookieBtn();
                //Is user previously has accepted cookies
                if (_self.CheckCookieExistance("cookiesAccepted")) {
                    _self.runCookieScripts();
                } else {
                    _self.openConsent();
                }
            }
        });
    };

    this.createGlobalCookieBtn = function() {
        var btnContainer = document.createElement("div");
        btnContainer.classList.add("cookie-button-container");

        var icon = document.createElement("i");
        icon.innerHTML = "&#9432;";

        var textEl = document.createElement("span");
        textEl.innerText = "Cookies";

        btnContainer.appendChild(icon);
        btnContainer.appendChild(textEl);
        btnContainer.tabIndex = 0; //add tabIndex

        var _self = this;

        btnContainer.addEventListener("click", function() {
            _self.openConsent();
        });

        // open consent with tabIndex
        btnContainer.addEventListener("keydown", function(e) {
            if (e.keyCode === 13) {
                _self.openConsent();
            }
        });

        var containerBtnContainer = document.querySelector(".cookie-container");

        containerBtnContainer.parentElement.insertBefore(
            btnContainer,
            containerBtnContainer
        );
    };

    this.setupConsentPopup = function() {
        var string = document.getElementById("CookieTableHead").value;
        this.cookiehead = JSON.parse(string);

        this.sortCookiesIntoCategories();
        var _self = this;

        //ACCEPT BUTTON CLICK
        document
            .querySelector("#acceptCookies")
            .addEventListener("click", () => {
                var today = new Date();
                today.setTime(today.getTime() + 730 * 24 * 60 * 60 * 1000); // 2 years (730 days) from today
                var expires = today.toUTCString();
                _self.setCategoryCookies();
                document.cookie =
                    "cookiesAccepted=true; expires=" + expires + "; path=/;";
                document
                    .getElementsByClassName("cookie-container")[0]
                    .classList.remove("cookie-container--show");
                _self.runCookieScripts();
            });
        document
            .querySelector("#rejectCookies")
            .addEventListener("click", () => {
                _self.rejectCookies();
                var today = new Date();
                today.setTime(today.getTime() + 730 * 24 * 60 * 60 * 1000); // 2 years (730 days) from today
                var expires = today.toUTCString();
                _self.setCategoryCookies();
                document.cookie =
                    "cookiesAccepted=true; expires=" + expires + "; path=/;";
                document
                    .getElementsByClassName("cookie-container")[0]
                    .classList.remove("cookie-container--show");
                _self.runCookieScripts();
            });

        var showDetailButtonText = document
            .querySelectorAll("[data-toggle-details]")[0]
            .getAttribute("data-details-show-title");
        var hideDetailsButtonText = document
            .querySelectorAll("[data-toggle-details]")[0]
            .getAttribute("data-details-hide-title");
        var showMoreAboutCookieButton = document.querySelectorAll(
            "[data-toggle-details]"
        )[0];

        var categoriesTypesButton = document.querySelectorAll(
            "[data-declartion-button]"
        )[0];
        var aboutCookiesButton = document.querySelectorAll(
            "[data-about-cookies-button]"
        )[0];

        var categoriesTypesContainer = document.querySelectorAll(
            "[data-categories-types-container]"
        )[0];
        var aboutCookiesContainer = document.querySelectorAll(
            "[data-detail-type-content]"
        )[0];

        showMoreAboutCookieButton.innerHTML = showDetailButtonText;

        categoriesTypesContainer.classList.toggle(
            "cookie-detail-tab-item--show"
        );
        categoriesTypesButton.classList.toggle(
            "cookie-detail-tab-button--active"
        );

        categoriesTypesButton.addEventListener("click", function() {
            if (
                !categoriesTypesContainer.classList.contains(
                    "cookie-detail-tab-item--show"
                )
            ) {
                categoriesTypesButton.classList.toggle(
                    "cookie-detail-tab-button--active"
                );
                aboutCookiesButton.classList.toggle(
                    "cookie-detail-tab-button--active"
                );

                categoriesTypesContainer.classList.toggle(
                    "cookie-detail-tab-item--show"
                );
                aboutCookiesContainer.classList.toggle(
                    "cookie-detail-tab-item--show"
                );
            }
        });

        aboutCookiesButton.addEventListener("click", function() {
            if (
                !aboutCookiesContainer.classList.contains(
                    "cookie-detail-tab-item--show"
                )
            ) {
                categoriesTypesButton.classList.toggle(
                    "cookie-detail-tab-button--active"
                );
                aboutCookiesButton.classList.toggle(
                    "cookie-detail-tab-button--active"
                );

                categoriesTypesContainer.classList.toggle(
                    "cookie-detail-tab-item--show"
                );
                aboutCookiesContainer.classList.toggle(
                    "cookie-detail-tab-item--show"
                );
            }
        });

        showMoreAboutCookieButton.addEventListener("click", function() {
            document
                .querySelectorAll("[data-cookie-detail]")[0]
                .classList.toggle("cookie-detail--show");
            if (showMoreAboutCookieButton.innerHTML === showDetailButtonText) {
                showMoreAboutCookieButton.innerHTML = hideDetailsButtonText;
            } else {
                showMoreAboutCookieButton.innerHTML = showDetailButtonText;
            }
        });
    };

    this.setCategoryCookies = function() {
        var _self = this;

        var checkboxContainers = document.getElementsByClassName(
            "cookie-setting-checkbox"
        );
        Array.prototype.forEach.call(checkboxContainers, function(container) {
            var checkbox = container.getElementsByTagName("input")[0];

            var cookieName = checkbox.id.replace("categoryCheckbox", "");

            //IF COOKIE EXISTS
            if (_self.CheckCookieExistance(cookieName)) {
                //REMOVE COOKIE
                document.cookie =
                    cookieName +
                    "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }

            if (checkbox.checked === true) {
                //ADD COOKIE
                var today = new Date();
                today.setTime(today.getTime() + 730 * 24 * 60 * 60 * 1000); // 2 years (730 days) from today
                var expires = today.toUTCString();
                document.cookie =
                    cookieName + "=allow; expires=" + expires + "; path=/;";
            }
        });
    };

    this.CheckCookieExistance = function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return true;
            }
        }
        return false;
    };

    this.openConsent = function() {
        if (!this.cookieHasBeenOpen) {
            this.setupConsentPopup();
            this.cookieHasBeenOpen = true;
        }

        document
            .getElementsByClassName("cookie-container")[0]
            .classList.add("cookie-container--show");
    };

    this.sortCookiesIntoCategories = function() {
        var _self = this;
        this.cookies.forEach(function(cookie) {
            if (_self.categories.length > 0) {
                var categoryExist = false;

                _self.categories.forEach(function(category) {
                    if (category.name === cookie.category) {
                        var catCookie = {
                            company: cookie.company,
                            description: cookie.categoryDescription,
                            expires: cookie.expires,
                            cookies: cookie.name
                        };

                        category.categoryCookies.push(catCookie);

                        categoryExist = true;
                    }
                });

                if (!categoryExist) {
                    var catCookie = {
                        company: cookie.company,
                        description: cookie.categoryDescription,
                        expires: cookie.expires,
                        cookies: cookie.name
                    };

                    var cat = {
                        name: cookie.category,
                        categoryCookies: [catCookie]
                    };

                    _self.categories.push(cat);
                }
            } else {
                var catCookie = {
                    company: cookie.company,
                    description: cookie.categoryDescription,
                    expires: cookie.expires,
                    cookies: cookie.name
                };

                var cat = {
                    name: cookie.category,
                    categoryCookies: [catCookie]
                };

                _self.categories.push(cat);
            }
        });

        this.createCheckboks();
        this.createCategoryTabels();
    };

    this.runCookieScripts = function() {
        if (this.CheckCookieExistance("CookieCategory2")) {
            // ikke obligatorisk
            this.runScripts();
        }
    };

    this.createCheckboks = function() {
        var _self = this;
        this.categories.forEach(function(category) {
            //Container for checkbox and label
            var checkboxContainer = document.createElement("div");
            checkboxContainer.className = "cookie-setting-checkbox";

            //Checkbox for toggleing each category
            var checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.name = "categoryCheckbox" + category.name;
            checkbox.id = "categoryCheckbox" + category.name;

            //Start tabIndex
            if (category.name !== "CookieCategory1") {
                checkboxContainer.tabIndex = 0;
            }
            checkboxContainer.addEventListener("keydown", function(e) {
                if (e.keyCode === 13) {
                    if (category.name !== "CookieCategory1") {
                        if (checkbox.checked) {
                            checkbox.checked = false;
                        } else {
                            checkbox.checked = true;
                        }
                    }
                }
            });
            //End tabIndex

            if (category.name === "CookieCategory1") {
                //MANDATORY
                checkbox.checked = true;
                checkbox.disabled = true;
            } else if (!_self.CheckCookieExistance("cookiesAccepted")) {
                //CHECK ALL ON FIRST VISIT
                checkbox.checked = true;
            } else if (_self.CheckCookieExistance(category.name)) {
                //CHECK IF COOKIE SET
                checkbox.checked = true;
            }

            //Label for checkbox
            var label = document.createElement("label");
            label.htmlFor = "categoryCheckbox" + category.name;
            label.appendChild(
                document.createTextNode(
                    document.getElementById(category.name).value
                )
            );

            //Append checkbox and label to container
            checkboxContainer.appendChild(checkbox);
            checkboxContainer.appendChild(label);

            //Append container to dom
            document
                .querySelectorAll("[data-categories]")[0]
                .appendChild(checkboxContainer);
        });
    };

    this.runCookie = function(cookie) {
        if (cookie.accept && !cookie.runned) {
            cookie.runned = true;
            eval("(" + cookie.accept + ")")();
        }
    };

    this.rejectCookies = () => {
        var checkboxContainers = document.getElementsByClassName(
            "cookie-setting-checkbox"
        );
        Array.prototype.forEach.call(checkboxContainers, function(container) {
            var checkbox = container.getElementsByTagName("input")[0];

            if (checkbox.name !== "categoryCheckboxCookieCategory1") {
                checkbox.checked = false;
            }
        });
    };

    this.runScripts = function() {
        var scriptTags = document.querySelectorAll("[type='text/plain']");
        var _self = this;
        scriptTags.forEach(function(script) {
            var scriptToLoad = script.cloneNode(true);
            scriptToLoad.setAttribute("type", "text/javascript");
            _self.insertAfter(script, scriptToLoad);
        });
    };

    this.insertAfter = function(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(
            newNode,
            referenceNode.nextSibling
        );
    };

    this.createCategoryTabels = function() {
        var self = this;
        this.categories.forEach(function(category, index) {
            var cookieCategoryTypeLink = document.createElement("a");

            //Start tabIndex effect
            cookieCategoryTypeLink.tabIndex = 0;
            cookieCategoryTypeLink.addEventListener("keydown", function(e) {
                if (e.keyCode === 13) {
                    var cookieCategoryToShow = document.querySelectorAll(
                        '[data-category-type="' + category.name + '"]'
                    )[0];
                    var allCookieCategories = document.querySelectorAll(
                        "[data-category-type]"
                    );

                    if (
                        !cookieCategoryToShow.classList.contains(
                            "cookie-type-container--show"
                        )
                    ) {
                        allCookieCategories.forEach(function(el) {
                            el.classList.remove("cookie-type-container--show");
                        });
                        cookieCategoryToShow.classList.add(
                            "cookie-type-container--show"
                        );
                        var allCookiteCategorieLinks = document.querySelectorAll(
                            "[data-categories-types] a"
                        );

                        allCookiteCategorieLinks.forEach(function(el) {
                            el.classList.remove("cookie-type-link--active");
                        });

                        this.classList.add("cookie-type-link--active");
                    }
                }
            });
            //End tabIndex effect

            cookieCategoryTypeLink.addEventListener("click", function() {
                var cookieCategoryToShow = document.querySelectorAll(
                    '[data-category-type="' + category.name + '"]'
                )[0];
                var allCookieCategories = document.querySelectorAll(
                    "[data-category-type]"
                );

                if (
                    !cookieCategoryToShow.classList.contains(
                        "cookie-type-container--show"
                    )
                ) {
                    allCookieCategories.forEach(function(el) {
                        el.classList.remove("cookie-type-container--show");
                    });
                    cookieCategoryToShow.classList.add(
                        "cookie-type-container--show"
                    );
                    var allCookiteCategorieLinks = document.querySelectorAll(
                        "[data-categories-types] a"
                    );
                    allCookiteCategorieLinks.forEach(function(el) {
                        el.classList.remove("cookie-type-link--active");
                    });
                    this.classList.add("cookie-type-link--active");
                }
            });

            cookieCategoryTypeLink.classList.add("cookie-type-link");
            //cookieCategoryTypeLink.setAttribute("data-category-type-link", category.name);

            var cookieCategoryTypeContainer = document.createElement("div");
            cookieCategoryTypeContainer.setAttribute(
                "data-category-type",
                category.name
            );
            cookieCategoryTypeContainer.className = "cookie-type-container";

            if (index === 0) {
                cookieCategoryTypeContainer.classList.add(
                    "cookie-type-container--show"
                );
                cookieCategoryTypeLink.classList.add(
                    "cookie-type-link--active"
                );
            }
            var cookiesHtml = "";
            category.categoryCookies.forEach(function(cookie) {
                var thisCookie = cookie;

                cookie.cookies.forEach(function(singleCookie) {
                    //Using template string function table body to generate html
                    var cookieHtml = self.tabelbody(
                        thisCookie,
                        singleCookie,
                        self.cookiehead
                    );
                    cookiesHtml += cookieHtml;
                });
            });

            //Using tmeplate string function, insert generated body into table head function
            var tabelHtml = self.tabelhead(cookiesHtml, self.cookiehead);
            cookieCategoryTypeContainer.innerHTML = tabelHtml;

            document
                .querySelectorAll("[data-categories-types-details]")[0]
                .appendChild(cookieCategoryTypeContainer);
            cookieCategoryTypeLink.appendChild(
                document.createTextNode(
                    document.getElementById(category.name).value
                )
            );
            document
                .querySelectorAll("[data-categories-types]")[0]
                .appendChild(cookieCategoryTypeLink);
        });
    };
}

/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
"document" in window.self &&
    (("classList" in document.createElement("_") &&
        (!document.createElementNS ||
            "classList" in
                document.createElementNS("http://www.w3.org/2000/svg", "g"))) ||
        (function(t) {
            "use strict";
            if ("Element" in t) {
                var e = "classList",
                    n = "prototype",
                    i = t.Element[n],
                    s = Object,
                    r =
                        String[n].trim ||
                        function() {
                            return this.replace(/^\s+|\s+$/g, "");
                        },
                    o =
                        Array[n].indexOf ||
                        function(t) {
                            for (var e = 0, n = this.length; e < n; e++)
                                if (e in this && this[e] === t) return e;
                            return -1;
                        },
                    c = function(t, e) {
                        (this.name = t),
                            (this.code = DOMException[t]),
                            (this.message = e);
                    },
                    a = function(t, e) {
                        if ("" === e)
                            throw new c(
                                "SYNTAX_ERR",
                                "An invalid or illegal string was specified"
                            );
                        if (/\s/.test(e))
                            throw new c(
                                "INVALID_CHARACTER_ERR",
                                "String contains an invalid character"
                            );
                        return o.call(t, e);
                    },
                    l = function(t) {
                        for (
                            var e = r.call(t.getAttribute("class") || ""),
                                n = e ? e.split(/\s+/) : [],
                                i = 0,
                                s = n.length;
                            i < s;
                            i++
                        )
                            this.push(n[i]);
                        this._updateClassName = function() {
                            t.setAttribute("class", this.toString());
                        };
                    },
                    u = (l[n] = []),
                    f = function() {
                        return new l(this);
                    };
                if (
                    ((c[n] = Error[n]),
                    (u.item = function(t) {
                        return this[t] || null;
                    }),
                    (u.contains = function(t) {
                        return -1 !== a(this, (t += ""));
                    }),
                    (u.add = function() {
                        for (
                            var t, e = arguments, n = 0, i = e.length, s = !1;
                            (t = e[n] + ""),
                                -1 === a(this, t) && (this.push(t), (s = !0)),
                                ++n < i;

                        );
                        s && this._updateClassName();
                    }),
                    (u.remove = function() {
                        var t,
                            e,
                            n = arguments,
                            i = 0,
                            s = n.length,
                            r = !1;
                        do {
                            for (t = n[i] + "", e = a(this, t); -1 !== e; )
                                this.splice(e, 1), (r = !0), (e = a(this, t));
                        } while (++i < s);
                        r && this._updateClassName();
                    }),
                    (u.toggle = function(t, e) {
                        t += "";
                        var n = this.contains(t),
                            i = n ? !0 !== e && "remove" : !1 !== e && "add";
                        return i && this[i](t), !0 === e || !1 === e ? e : !n;
                    }),
                    (u.toString = function() {
                        return this.join(" ");
                    }),
                    s.defineProperty)
                ) {
                    var h = { get: f, enumerable: !0, configurable: !0 };
                    try {
                        s.defineProperty(i, e, h);
                    } catch (t) {
                        (void 0 !== t.number && -2146823252 !== t.number) ||
                            ((h.enumerable = !1), s.defineProperty(i, e, h));
                    }
                } else s[n].__defineGetter__ && i.__defineGetter__(e, f);
            }
        })(window.self),
    (function() {
        "use strict";
        var t = document.createElement("_");
        if ((t.classList.add("c1", "c2"), !t.classList.contains("c2"))) {
            var e = function(t) {
                var i = DOMTokenList.prototype[t];
                DOMTokenList.prototype[t] = function(t) {
                    var e,
                        n = arguments.length;
                    for (e = 0; e < n; e++) (t = arguments[e]), i.call(this, t);
                };
            };
            e("add"), e("remove");
        }
        if ((t.classList.toggle("c3", !1), t.classList.contains("c3"))) {
            var n = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(t, e) {
                return 1 in arguments && !this.contains(t) == !e
                    ? e
                    : n.call(this, t);
            };
        }
        t = null;
    })());

var cookie = new CookieConsent();
cookie.init();
